
import { defineComponent, PropType } from 'vue'

import { DeliveryOrder } from '@/new-services/types/delivery'

export default defineComponent({
    props: {
        order: {
            type: Object as PropType<DeliveryOrder>,
            required: true,
        },
    },
})
